module.exports = __webpack_public_path__ + "img/404_art.3302c282.jpg";